import { getRequest, severityCode } from "./httpClientUnauthorized";

const END_POINT = "userAccess";

const getDemoLogin = async (type) => {
  return await getRequest(`${END_POINT}/demoLogin/${type}`);
};

export { getDemoLogin, severityCode };
